module.exports = __webpack_public_path__ + "img/part5-8.01236751.png";